/**
 * Platform Admins API - control-plane platform-admin management endpoints
 */

import type {
  ListPlatformAdminsResponse,
  CreatePlatformAdminRequest,
  CreatePlatformAdminResponse,
  UpdatePlatformAdminStatusResponse,
  PlatformAdminStatus,
} from '@resolve-ai/shared';

import { fetchWithAuth } from './api-client';

export const platformAdminsApi = {
  async list(): Promise<ListPlatformAdminsResponse> {
    return fetchWithAuth<ListPlatformAdminsResponse>('/platform-admins');
  },

  async create(payload: CreatePlatformAdminRequest): Promise<CreatePlatformAdminResponse> {
    return fetchWithAuth<CreatePlatformAdminResponse>('/platform-admins', {
      method: 'POST',
      body: JSON.stringify(payload),
    });
  },

  async updateStatus(id: string, status: PlatformAdminStatus): Promise<UpdatePlatformAdminStatusResponse> {
    return fetchWithAuth<UpdatePlatformAdminStatusResponse>(`/platform-admins/${id}`, {
      method: 'PATCH',
      body: JSON.stringify({ status }),
    });
  },
};
